var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upgrade_btn", on: { click: _vm.upgradeClick } },
    [_vm._v("\n  " + _vm._s(_vm.locales("upgrade_rate_btn")) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }